import { LayoutGrid } from "lucide-react"
import { useState } from "react"
import { cn } from "@/shared/lib/utils"
import { Skeleton } from "@/shared/ui/skeleton"

interface TaxonomyCoverProps {
	iconUrl?: string | null
	fallbackClassName?: string
	className?: string
}

export function TaxonomyCover({ iconUrl, fallbackClassName, className }: TaxonomyCoverProps) {
	const [broken, setBroken] = useState(false)
	const [loaded, setLoaded] = useState(false)

	if (!iconUrl || broken) {
		return <LayoutGrid className={cn("text-primary", fallbackClassName)} />
	}

	return (
		<>
			{!loaded && <Skeleton className="absolute inset-0 rounded-none" />}
			<img
				src={iconUrl}
				alt=""
				loading="lazy"
				decoding="async"
				onLoad={() => setLoaded(true)}
				onError={() => setBroken(true)}
				className={cn(
					"h-full w-full object-cover transition-opacity duration-200",
					loaded ? "opacity-100" : "opacity-0",
					className,
				)}
			/>
		</>
	)
}
